import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import StarsLink from '@swf/components/StarsLink/StarsLink';
import Translation from '@swf/components/Translation/Translation';
import { call } from '@swf/core/api/embedded';
import { FeatureFlag, ResolverTag, Site } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import InfoBlock from '../InfoBlock/InfoBlock';

import {
  TXTWCL_How_can_I_manage_my_spendingX,
  TXTWCL_If_youXre_not_sure_about_takin_ELL_2,
  TXTWCL_If_youXre_not_sure_about_takin_ELL_3,
  TXTWCL_Learn_more_about_XaXResponsibl_ELL,
  TXTWCL_To_find_out_more_about_safe_ga_ELL,
  TXTWCL_You_can_also_set_a_XaXloss_lim_ELL
} from './LearnMoreAboutRG.messages.json';

const LearnMoreAboutRG = () => {
  const depositLimitPath = useSelector(select.account.getDepositLimitPath);
  const site = useSelector(select.site.getId);
  const isEmbedded = useSelector(select.site.isEmbedded);
  const { modal } = useDispatch<Dispatch>();
  const visibilityOASISExclusionOption = useFeature(FeatureFlag.VisibilityOASISExclusionOption);

  const openRestrictDepositLimit = () => {
    isEmbedded
      ? call(['app', 'execute'], 'account/responsible/restrict-deposit-limit')
      : modal.replace([{ path: depositLimitPath }]);
  };
  const openAccumulatedLossLimit = () => {
    isEmbedded
      ? call(['app', 'execute'], 'account/responsible/accumulated-loss-limit')
      : modal.replace([{ path: '/account/responsible/accumulated-loss-limit' }]);
  };

  switch (true) {
    case visibilityOASISExclusionOption:
      return (
        <>
          {' '}
          <Translation tagName="b" {...TXTWCL_How_can_I_manage_my_spendingX} />
          <p>
            <Translation
              {...TXTWCL_If_youXre_not_sure_about_takin_ELL_2}
              values={{
                a: (msg: string) => <StarsLink onClick={openRestrictDepositLimit}>{msg}</StarsLink>
              }}
            />{' '}
            <Translation
              {...TXTWCL_You_can_also_set_a_XaXloss_lim_ELL}
              values={{
                a: (msg: string) => <StarsLink onClick={openAccumulatedLossLimit}>{msg}</StarsLink>
              }}
            />
          </p>
          <Translation
            tagName="p"
            {...TXTWCL_To_find_out_more_about_safe_ga_ELL}
            values={{
              a: (msg: string) => (
                <ResolverLink resolverTag={ResolverTag.RGPage}>{msg}</ResolverLink>
              )
            }}
          />{' '}
        </>
      );
    case site === Site.FR:
      return (
        <>
          <InfoBlock title={TXTWCL_How_can_I_manage_my_spendingX}>
            <div>
              <Translation
                {...TXTWCL_If_youXre_not_sure_about_takin_ELL_3}
                values={{
                  a: (msg: string) => (
                    <StarsLink onClick={openRestrictDepositLimit}>{msg}</StarsLink>
                  )
                }}
              />
            </div>
          </InfoBlock>
          <Translation
            tagName="p"
            {...TXTWCL_To_find_out_more_about_safe_ga_ELL}
            values={{
              a: (msg: string) => (
                <ResolverLink resolverTag={ResolverTag.RG18Logo}>{msg}</ResolverLink>
              )
            }}
          />
        </>
      );
    case site === Site.UK:
      return (
        <Translation
          {...TXTWCL_Learn_more_about_XaXResponsibl_ELL}
          values={{
            a: (msg: string) => (
              <ResolverLink resolverTag={ResolverTag.HelpResponsibleGaming}>{msg}</ResolverLink>
            )
          }}
        />
      );
    default:
      return (
        <Translation
          tagName="p"
          {...TXTWCL_To_find_out_more_about_safe_ga_ELL}
          values={{
            a: (msg: string) => (
              <ResolverLink resolverTag={ResolverTag.SelfExclusionResponsibleGamingPS}>
                {msg}
              </ResolverLink>
            )
          }}
        />
      );
  }
};

export default LearnMoreAboutRG;
